import { useTranslation } from 'react-i18next'
import { Item } from '../item'

import c from './assets/sass/list.module.scss'

export const List = () => {
    const { t } = useTranslation()
    return (
        <ul className={c.component}>
            <Item
                type="advent"
                title={t('games.advent.title')}
                subTitle={t('games.advent.subtitle')}
                comingSoon={false}
                soonText={t('games.adventSoon')}
            />
            <Item
                type="mines"
                title={t('games.mines.title')}
                subTitle={t('games.mines.subtitle')}
                comingSoon={false}
            />
            <Item
                type="battles"
                title={t('games.battles.title')}
                subTitle={t('games.battles.subtitle')}
                comingSoon={false}
            />
        </ul>
    )
}
